import { Category } from '@wix/ambassador-achievements-categories-v3-category/types';

export enum ButtonState {
  Default = 'default',
  Hover = 'hover',
}

export enum CategoriesTabsState {
  Regular = 'regular',
  Hover = 'hover',
  Selected = 'selected',
}

export interface ISettingsEvents {
  buttonState: ButtonState;
  showMAEmptyList: boolean;
  setCategoryToPreview: string;
  onCategoryChanged: Category;
  categoriesTabChange: CategoriesTabsState;
}

export enum ChallengesCustomEvents {
  buttonState = 'buttonState',
  categoriesTabState = 'categoriesTabChange',
}
